export default __webpack_public_path__ + "static/media/video_home_bg_mobile.5b0d20a8.mp4";